// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Component-specific styles */

/* ResourceSection component styles */
.border-orthodox-gold-400\\/30 {
  border-color: rgba(242, 202, 84, 0.3);
}

/* Calendar and events styling */
.calendar-event {
  padding: 1rem;
  border-left-width: 4px;
  border-color: #f2ca54; /* orthodox-gold-500 */
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-bottom: 1rem;
}

.event-date {
  font-size: 0.875rem; /* text-sm */
  color: #6b7280; /* text-gray-500 */
  margin-bottom: 0.25rem; /* mb-1 */
}

.event-title {
  font-family: var(--font-playfair), Georgia, serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #1a2f4d; /* orthodox-blue-800 */
  margin-bottom: 0.25rem;
}

.event-description {
  color: #374151; /* text-gray-700 */
}

/* Styles for religious content */
.scripture-quote {
  font-style: italic;
  color: #1a2f4d; /* orthodox-blue-800 */
  background-color: #fdf7e7; /* orthodox-gold-100 */
  padding: 1rem;
  border-left-width: 4px;
  border-color: #f2ca54; /* orthodox-gold-500 */
  border-radius: 0.25rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.church-heading {
  font-family: var(--font-playfair), Georgia, serif;
  color: #1a2f4d; /* orthodox-blue-800 */
  margin-bottom: 1rem;
}

/* Light mode styling always applied */
.bg-orthodox-blue-100 {
  background-color: #e6edf5;
  border-color: #1a2f4d;
}

.bg-orthodox-blue-100 h4, 
.bg-orthodox-blue-100 p {
  color: #1a2f4d;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/index.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,qCAAqC;AACrC;EACE,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB,EAAE,sBAAsB;EAC7C,uBAAuB;EACvB,sBAAsB;EACtB,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,cAAc,EAAE,kBAAkB;EAClC,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,sBAAsB;EACtC,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,cAAc,EAAE,sBAAsB;EACtC,yBAAyB,EAAE,sBAAsB;EACjD,aAAa;EACb,sBAAsB;EACtB,qBAAqB,EAAE,sBAAsB;EAC7C,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,cAAc,EAAE,sBAAsB;EACtC,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/* Component-specific styles */\n\n/* ResourceSection component styles */\n.border-orthodox-gold-400\\/30 {\n  border-color: rgba(242, 202, 84, 0.3);\n}\n\n/* Calendar and events styling */\n.calendar-event {\n  padding: 1rem;\n  border-left-width: 4px;\n  border-color: #f2ca54; /* orthodox-gold-500 */\n  background-color: white;\n  border-radius: 0.25rem;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  margin-bottom: 1rem;\n}\n\n.event-date {\n  font-size: 0.875rem; /* text-sm */\n  color: #6b7280; /* text-gray-500 */\n  margin-bottom: 0.25rem; /* mb-1 */\n}\n\n.event-title {\n  font-family: var(--font-playfair), Georgia, serif;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #1a2f4d; /* orthodox-blue-800 */\n  margin-bottom: 0.25rem;\n}\n\n.event-description {\n  color: #374151; /* text-gray-700 */\n}\n\n/* Styles for religious content */\n.scripture-quote {\n  font-style: italic;\n  color: #1a2f4d; /* orthodox-blue-800 */\n  background-color: #fdf7e7; /* orthodox-gold-100 */\n  padding: 1rem;\n  border-left-width: 4px;\n  border-color: #f2ca54; /* orthodox-gold-500 */\n  border-radius: 0.25rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.church-heading {\n  font-family: var(--font-playfair), Georgia, serif;\n  color: #1a2f4d; /* orthodox-blue-800 */\n  margin-bottom: 1rem;\n}\n\n/* Light mode styling always applied */\n.bg-orthodox-blue-100 {\n  background-color: #e6edf5;\n  border-color: #1a2f4d;\n}\n\n.bg-orthodox-blue-100 h4, \n.bg-orthodox-blue-100 p {\n  color: #1a2f4d;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
